var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPillOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  style: {
    width: 20,
    height: 16
  },
  viewBox: "0 0 29 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0C9BAB",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "m22.507 27.93 1.231-4.595.695-2.638 1.738-6.595a9.543 9.543 0 0 0-6.8-11.666 9.543 9.543 0 0 0-11.667 6.8l-1.737 6.596-3.134 11.845s-1.436 4.827.564 8.327 4.5 4.5 4.5 4.5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14.896,
  cy: 33.504,
  r: 6.75,
  stroke: "#0C9BAB",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0C9BAB",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m11.896 33.504 2.5 2.5 3.5-4.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0C9BAB",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m5.896 19.004 17 4.555"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0C9BAB",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M18.896 6.504s2.57 1.45 3.465 3c.894 1.55.866 4.5.866 4.5",
  opacity: 0.4
})));
export default SvgPillOk;